import { API, Storage } from 'aws-amplify';
import { listUserProfiles } from '../../graphql/queries';

export const FetchProfiles = () => {
  // const myFilter2 = { owner: { eq: 'kkdub' } };
  async function fetchUserProfiles() {
    const apiData = await API.graphql({
      query: listUserProfiles,
      // variables: { filter: myFilter2 },
    });
    const userProfilesFromAPI = apiData.data.listUserProfiles.items.filter(
      (items) => items['_deleted'] !== true
    );
    await Promise.all(
      userProfilesFromAPI.map(async (profile) => {
        if (profile.profileImage) {
          const url = await Storage.get(profile.username);
          profile.profileImage = url;
        }
        return profile;
      })
    );
    // console.log(userProfilesFromAPI);
    return userProfilesFromAPI;
  }
  const data = fetchUserProfiles();
  return data;
};
